(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function scAuthorizeService($http, $injector) {
  var _this = this;

  this.getCampaignsServiceId = function () {
    var campaignsService = $injector.get('scCampaignsService');

    return _.get(campaignsService, 'active.current.id', null);
  };

  this.getOrganizationsServiceId = function () {
    var organizationsService = $injector.get('scOrganizationsService');

    return _.get(organizationsService, 'active.current.id', null);
  };

  // builds default scopes object if not provided
  this.getScopes = function () {
    // attempt to grab the campaign and org ids from SC
    // otherwise, check for the active id within their services
    var campaignId = _.get(SC, 'campaign.id', null) || _this.getCampaignsServiceId();
    var organizationId = _.get(SC, 'organization.id', null) || _this.getOrganizationsServiceId();
    return { campaign: [campaignId], organization: [organizationId] };
  };

  // Calls /permissions endpoint in frs-api
  this.isAuthorized = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(permissions) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var scopes, memberId, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (permissions) {
                _context.next = 2;
                break;
              }

              throw new Error('You must provide a permissions param');

            case 2:
              scopes = args.scopes || _this.getScopes();
              memberId = _.get(SC, 'member.id', null);

              // if they're not logged in, they don't have any permissions

              if (memberId) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', [{ result: false }]);

            case 6:
              _context.next = 8;
              return $http({
                method: 'POST',
                url: '/frs-api/permissions/' + memberId,
                data: { permissions: permissions, scopes: scopes }
              });

            case 8:
              result = _context.sent;
              return _context.abrupt('return', result.data);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

angular.module('classy').service('scAuthorizeService', ['$http', '$injector', scAuthorizeService]);
})();